import { api } from '../utils/api/api-client';

/**
 * Archival is the only workspace lifecycle call CRM's client still makes.
 *
 * Listing, creating, renaming and choosing the default are platform concerns —
 * `TopoloAppRoot` reads them straight from Auth, which holds the one copy of a
 * workspace's name, slug and default flag. This module used to wrap all five;
 * the four that are gone were how an app-side view of a workspace could drift
 * from the real record.
 */

interface CrmWorkspaceEnvelope {
  archivedWorkspaceId?: string;
  data?: CrmWorkspaceEnvelope;
}

interface CrmWorkspaceApiClient {
  delete<T>(_path: string): Promise<{ success: boolean; data?: T; error?: string }>;
}

function unwrap(response: CrmWorkspaceEnvelope): CrmWorkspaceEnvelope {
  return response.data ?? response;
}

/**
 * Ask the API to archive a workspace. The API confirms it is empty — the one
 * question only CRM can answer — and the platform decides the rest.
 */
export async function archiveCrmWorkspace(
  workspaceId: string,
  client: CrmWorkspaceApiClient = api
): Promise<string | null> {
  const response = await client.delete<CrmWorkspaceEnvelope>(`/crm/workspaces/${workspaceId}`);
  if (!response.success || !response.data) {
    throw new Error(response.error || 'Workspace action failed');
  }
  return unwrap(response.data).archivedWorkspaceId ?? null;
}

export type { CrmWorkspaceApiClient };
